import { createAction } from '@reduxjs/toolkit';

/**
 * Open the settings dialog
 */
export const openSettingsDialog = createAction('settingsDialog/openSettingsDialog');

/**
 * Close the settings dialog
 */
export const closeSettingsDialog = createAction('settingsDialog/closeSettingsDialog');

/**
 * Toggle the settings dialog
 */
export const toggleSettingsDialog = createAction('settingsDialog/toggleSettingsDialog');

/**
 * Set the settings dialog open state
 */
export const setSettingsDialogOpen = createAction<boolean>('settingsDialog/setSettingsDialogOpen');
